import api from '@/services/api'

export const updateUsersStage = async (users, eventID) => {
    try {
        return await api.post('users/bulk/update-stage', {
            users,
            event_id: eventID,
        })
    } catch (e) {
        console.log(e)
        throw e
    }
}
